'use client';

import ContentPage from 'components/ContentPage';
import FullScreenLoadingSpinner from 'components/FullScreenLoadingSpinner';
import useContentPage from 'hooks/useContentPage';
import { NOTFOUND_SLUG } from 'models/contentPages/types';

export default function NotFound() {
  const { data: notFoundPage, loading } = useContentPage(NOTFOUND_SLUG);

  return (
    <>
      {!loading && notFoundPage ? (
        <ContentPage {...notFoundPage} />
      ) : (
        <FullScreenLoadingSpinner message="Page not found" />
      )}
    </>
  );
}
